import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { useHistory } from 'react-router-dom';
import { Modal, message } from 'antd';
import PropTypes from 'prop-types';
import { Button } from '../../../components/buttons/buttons';

const Popup = ({ messagePopup, setMessagePopup, pageType, onNavigate, onDraftSend, onDeleteSend, templateIDSS, close, onclose, OnCancel }) => {
    const history = useHistory();
    const handleClose = () => {
        if (pageType === "Email") {
            setMessagePopup(false)
            history.push('/Home')
            message.info("Redirected to Home")
        }
        else if (pageType === "Meeting") {
            setMessagePopup(false)
        }
        else {
            setMessagePopup(false)
        }
    }
    return (
        <>
            <Modal
                title={!pageType ? "Complete Mandatory Fields" : (
                    (pageType === "Email" || pageType === "Meeting") ? "Email configuration?" :
                        (pageType === "DraftMail" ? "Discard draft?" : "Cancel?"))}
                open={messagePopup}
                onCancel={handleClose}
                maskClosable={false}
                // width={700}
                footer={!pageType ? false : [
                    <div>
                        {pageType === "DraftMail" ?
                            <>
                                <Button htmlType="submit" size="small" className="gray-button"
                                    // onClick={() => onDeleteSend(templateIDSS)}
                                    onClick={() => onDraftSend(templateIDSS, "SaveCheck")}
                                >
                                    <FeatherIcon icon="x" /> No
                                </Button>
                                <Button htmlType="submit" size="small" className="button_colors"
                                    onClick={() => onDeleteSend(templateIDSS)}>
                                    <FeatherIcon icon="check" /> Yes
                                </Button>
                                {/* <Button htmlType="submit" size="small" className="gray-button" onClick={() => OnCancel()}>
                                    <FeatherIcon icon="x" /> Cancel
                                </Button> */}
                            </> :
                            pageType === "Close" ?
                                <>
                                    <Button htmlType="submit" size="small" className="gray-button"
                                        onClick={() => onDraftSend(templateIDSS, "SaveCheck")}
                                    >
                                        <FeatherIcon icon="x" /> No
                                    </Button>
                                    <Button htmlType="submit" size="small" className="button_colors"
                                        onClick={() => OnCancel()}>
                                        <FeatherIcon icon="check" /> Yes
                                    </Button>
                                </> :
                                (pageType === "BulkMail" || pageType === "QSI") ?
                                    <>
                                        <Button htmlType="submit" size="small" className="gray-button" onClick={() => onclose()}>
                                            <FeatherIcon icon="x" /> No
                                        </Button>
                                        <Button className="button_colors" size="small" onClick={() => close()}>
                                            <FeatherIcon icon="check" className="text_iconspace" />Yes
                                        </Button>
                                    </>
                                    :
                                    <>
                                        {(pageType === "Email" || pageType === "Meeting") && <>
                                            <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                                <FeatherIcon icon="x" /> Cancel
                                            </Button>

                                            <Button htmlType="submit" size="small" className="button_colors" onClick={onNavigate}>
                                                <FeatherIcon icon="tool" /> Setup
                                            </Button>
                                        </>
                                        }
                                    </>
                        }
                    </div>
                ]}
            >
                <div style={{ padding: "0px 20px" }} >
                    <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                        {pageType === "Email" ?
                            <p>No email configuration found! To get started with emails, click on the setup button and configure your email.</p>
                            : pageType === "DraftMail" ?
                                <p>Are you sure you want to discard this draft?</p>
                                : pageType === "Meeting" ?
                                    <p>No email configuration found! To get started with meetings, click on the setup button and configure your email.</p>
                                    : (pageType === "BulkMail" || pageType === "QSI" || pageType === "Close") ?
                                        <p>You may have unsaved changes. Are you sure you want to leave this draft?</p>
                                        : <p>To proceed to the next stage in the pipeline, you must complete the mandatory fields on the deals page. Please update those fields and try again.</p>
                        }</div>
                </div>
            </Modal >

        </>
    );
};

Popup.propTypes = {
    messagePopup: PropTypes.bool.isRequired,
    setMessagePopup: PropTypes.func.isRequired,
    pageType: PropTypes.string.isRequired,
    onNavigate: PropTypes.func.isRequired,
    OnCancel: PropTypes.func.isRequired,
    onDraftSend: PropTypes.func.isRequired,
    onDeleteSend: PropTypes.func.isRequired,
    onclose: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    templateIDSS: PropTypes.number.isRequired,
};

export default Popup;